import { render } from "./MultiModule.vue?vue&type=template&id=7dcd9e88&scoped=true"
import script from "./MultiModule.vue?vue&type=script&lang=js"
export * from "./MultiModule.vue?vue&type=script&lang=js"

import "./MultiModule.vue?vue&type=style&index=0&id=7dcd9e88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcd9e88"]])

export default __exports__